// A finding is not a table of its own: it is a task, and this file is what
// makes that readable on screen.
//
// TWO FACTS FROM THE BACKEND, and neither is guessed here:
//
//   1. A finding is a task with `origin_task_id` set. `POST /agent/findings`
//      writes it; nothing else does — the admin create body does not even
//      accept the field, on purpose (T9.6), because a finding without the task
//      it came out of is an anonymous complaint.
//   2. Its severity lives in `priority`. `tasks` has no `severity` column, so
//      TaskManager maps the four levels onto the number that actually changes
//      what happens: a critical finding has to come up first in triage.
//
// THE MAP IS INJECTIVE ON PURPOSE — four levels, four numbers, none repeated —
// which is the only reason severity can be read back out of the column. If two
// levels ever shared a number, the column would say less than the parameter did
// and this file would be inventing the difference.

export const SEVERITIES = [
    { key: 'critical', priority: 100, label: 'Crítico' },
    { key: 'high',     priority: 50,  label: 'Alto' },
    { key: 'medium',   priority: 10,  label: 'Medio' },
    { key: 'low',      priority: 0,   label: 'Bajo' },
];

const BY_PRIORITY = new Map(SEVERITIES.map(level => [level.priority, level]));

// Null when the number is not one of the four. That is not a bug to hide: a
// finding whose priority somebody edited by hand no longer carries a severity,
// and showing the raw number says so honestly instead of rounding it to the
// nearest level and losing the fact that it was touched.
export function severityOf(priority) {
    return BY_PRIORITY.get(Number(priority)) ?? null;
}

export function isFinding(task) {
    return task?.origin_task_id != null;
}

// Worst first, and within a level the oldest first: a critical one from last
// month is not less urgent than a critical one from this morning.
export function byUrgency(a, b) {
    if (b.priority !== a.priority) return b.priority - a.priority;
    return new Date(a.createdAt) - new Date(b.createdAt);
}
